import {
	apolloClient,
	DISMISS_BULLETIN_MUTATION,
	GET_AUTHORIZED_WORKER,
	GET_BULLENTINS_QUERY,
	GET_CHECKOUT_TIME_WORKER,
	GET_GENERAL_RANKED_JOBS_QUERY,
	GET_HOT_JOBS_QUERY,
	GET_JOB_DISCOVERS_QUERY,
	GET_SUGGESTION_JOBS_QUERY,
} from '~/common/apollo'
import { action, computed, observable, store } from '~/common/mobx.decorator'
import { authStore, notifyStore } from '~/stores'
import { includes, isEmpty } from 'lodash'
import { careFindJobStore } from '~/features/care-find-job/care-find-job.store'
import { careStore } from '~/companies/care/care.store'
import { convertToTimeZone } from '~/common/helpers'

@store()
class CareHomeStore {
	@observable numCityCall = 0
	@observable numJobCall = 0

	@observable citiesMatches = []
	@observable workAuthorized = {}
	@observable hotJobs = []
	@observable suggestedJobs = []
	@observable popularCities = []
	@observable bulletins = []
	@observable discover = {}
	@observable phoneAuthorized = null
	@observable phoneVerifiedAt = null
	@observable workerInfo = null
	@observable settings = {}
	@observable discoverLastSearch = {}
	@observable totalCountLastSearch = 0
	@observable similarJobFilter = {}
	@observable lastSearchTitle = ''
	@observable listWorkerCheckout = null
	@observable summaryWorkedShiftActivities = null
	@observable listWorkerCheckoutDetail = null
	@observable activeCheckoutId = ''
	@observable currentCheckoutItem = null

	@computed
	get citiesMatchesItems() {
		return this.citiesMatches
	}

	@action
	setSimilarJobFilter = (filter) => {
		this.similarJobFilter = careFindJobStore.transferDataParams(filter)
	}

	@computed
	get hotJobsItems() {
		return this.hotJobs
	}

	@computed
	get suggestedJobsItems() {
		return this.suggestedJobs
	}

	@computed
	get popularCitiesItems() {
		return this.popularCities
	}

	@action
	fetchPopularCities = async () => {
		try {
			const response = await apolloClient.query({
				query: GET_GENERAL_RANKED_JOBS_QUERY,
			})
			this.popularCities = response?.data?.popularCities
		} catch (error) {
			console.error(error.message)
		}
	}

	@action
	fetchSuggestedJobs = async () => {
		const response = await apolloClient.query({ query: GET_SUGGESTION_JOBS_QUERY, variables: { limit: 5, offset: 0 } })
		this.suggestedJobs = response?.data?.suggestionJobs?.nodes
	}
	@action
	setHotJob = (jobs) => {
		this.hotJobs = jobs
	}
	@action
	setSuggestedJob = (jobs) => {
		this.suggestedJobs = jobs
	}

	@action
	fetchHotJobs = async () => {
		const response = await apolloClient.query({
			query: GET_HOT_JOBS_QUERY,
			variables: {
				filter: { hotJob: true },
				first: 3,
			},
		})
		this.hotJobs = response.data?.searchJobs?.nodes
	}

	@action
	fetchGuidances = async () => {
		const { data } = await apolloClient.query({
			query: GET_BULLENTINS_QUERY,
		})

		this.bulletins = data?.bulletins.filter((item) => item?.kind !== 'onboarding' && item?.kind !== 'refer')

		if (authStore?.isAnonymous) {
			const deleteBulletinsAnoParsed = JSON.parse(window.localStorage.getItem('deleteBulletinsAno')) || []
			let deleteBulletinsAno = isEmpty(deleteBulletinsAnoParsed) ? [] : deleteBulletinsAnoParsed
			this.bulletins = this.bulletins?.filter((item) => !includes(deleteBulletinsAno, item.id))
			return
		}
	}

	@action
	fetchWorkerCheckout = async () => {
		const timezone = careStore.timezone
		const dataValue = convertToTimeZone(timezone)
		try {
			const { data } = await apolloClient.query({
				query: GET_CHECKOUT_TIME_WORKER,
				variables: {
					filter: {
						isPerDiem: true,
						scheduledStartTimeBetween: dataValue,
					},
				},
			})
			//
			this.listWorkerCheckout = data?.searchWorkerAssignments.nodes
			// this.listWorkerCheckout = mockData
		} catch (error) {
			console.error(error.message)
		}
	}

	@action
	fetchWorkerCheckoutDetail = async (jobId) => {
		const timezone = careStore.tenant
		const dataValue = convertToTimeZone(timezone)
		try {
			const { data } = await apolloClient.query({
				query: GET_CHECKOUT_TIME_WORKER,
				variables: {
					filter: {
						isPerDiem: true,
						jobId: jobId,
						scheduledStartTimeBetween: dataValue,
					},
				},
			})
			return data?.searchWorkerAssignments.nodes
		} catch (error) {
			console.error(error.message)
		}
	}
	@action
	setListWorkerCheckout = (value) => {
		return (this.listWorkerCheckout = value)
	}

	@action
	setCurrentCheckoutItem = (value) => {
		return (this.currentCheckoutItem = value)
	}

	@action
	setActiveCheckoutId = (value) => {
		return (this.activeCheckoutId = value)
	}

	@action
	dismissBulletinForAnonymous = async (bulletinId) => {
		try {
			const deleteBulletinsAnoParsed = JSON.parse(window.localStorage.getItem('deleteBulletinsAno')) || []
			let deleteBulletinsAno = isEmpty(deleteBulletinsAnoParsed) ? [] : deleteBulletinsAnoParsed
			deleteBulletinsAno.push(bulletinId)
			window.localStorage.setItem('deleteBulletinsAno', JSON.stringify(deleteBulletinsAno))
			this.fetchGuidances()
			notifyStore.success('$MESSAGES.SUCCESSFUL')
		} catch (error) {
			notifyStore.error(error.message)
		}
	}

	@action
	dissmisBulletin = async (bulletinId) => {
		if (authStore.isAnonymous) {
			this.dismissBulletinForAnonymous(bulletinId)
			return
		}

		try {
			await apolloClient.mutate({
				mutation: DISMISS_BULLETIN_MUTATION,
				variables: { bulletinId },
			})
			notifyStore.success('$MESSAGES.SUCCESSFUL')
			this.fetchGuidances()
		} catch (error) {
			notifyStore.error(error.message)
		}
	}

	@action
	fetchDiscovers = async () => {
		try {
			const { data } = await apolloClient.query({
				query: GET_JOB_DISCOVERS_QUERY,
			})
			this.discover = data?.discovers
		} catch (error) {
			console.error(error.message)
		}
	}

	@action
	fetchWorkerAuthorized = async () => {
		try {
			const { data } = await apolloClient.query({
				query: GET_AUTHORIZED_WORKER,
				variables: {
					workerId: authStore.id,
				},
			})
			this.workerInfo = data?.worker
			this.phoneAuthorized = data?.worker?.phone
			this.phoneVerifiedAt = data?.worker?.phoneVerifiedAt
		} catch (error) {
			notifyStore.error(error.message)
		}
	}
}

export const careHomeStore = new CareHomeStore()
